function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1 0a1 1 0 00-1 1v2a1 1 0 001 1h5a1 1 0 001-1V1a1 1 0 00-1-1H1zm0 6a1 1 0 00-1 1v2a1 1 0 001 1h5a1 1 0 001-1V7a1 1 0 00-1-1H1zm0 6a1 1 0 00-1 1v2a1 1 0 001 1h5a1 1 0 001-1v-2a1 1 0 00-1-1H1zm9-12a1 1 0 00-1 1v2a1 1 0 001 1h5a1 1 0 001-1V1a1 1 0 00-1-1h-5zm0 6a1 1 0 00-1 1v2a1 1 0 001 1h5a1 1 0 001-1V7a1 1 0 00-1-1h-5z"
});

function SvgMyWorkBoard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgMyWorkBoard;